import React from "react";
import styled from "styled-components";
import { Box, Row } from "@motorata/base-ui.components.atoms._atoms";
import { LabelH3, P } from "@motorata/base-ui.components.atoms.typography";
import Icon from "@motorata/base-ui.components.atoms.icon";
import Alert from "@motorata/base-ui.components.molecules.alert";

const AddOfferVinDecoder = ({ status, children }) => {
  return (
    <Wrapper>
      <Content>
        <Row>
          <Icon height="35px" width="35px" icon="org-vin" />
          <Box marginLeft="S">
            <LabelH3 color="primary" marginBottom="XXS">Chcesz pobrać dane pojazdu automatycznie?</LabelH3>
            <P margin="0" small>Podaj numer VIN, a my postaramy się pobrać dane pojazdu automatycznie, jeśli tylko jest to możliwe.</P>
          </Box>
        </Row>
        <Box>
          {children}
        </Box>
      </Content>
      {
        status === "success" &&
        <Alert type="success" small marginBottom="0" marginTop="S">Twoje dane zostały pomyślnie pobrane</Alert>
      }
      {
        status === "error" &&
        <Alert type="error" small marginBottom="0" marginTop="S">Niestety nie udało nam się pobrać danych</Alert>
      }
    </Wrapper>
  );
};

export default AddOfferVinDecoder;

const Content = styled(Box)`
  display: flex;
  grid-gap: ${({ theme }) => theme.space.M};
  align-items: center;

  >div:nth-child(1){
    flex: 1;
  }
  >div:nth-child(2){
    width: 350px;
  }
  
  @media (max-width: 800px){
    flex-direction: column;
    grid-gap: ${({ theme }) => theme.space.S};

    >div:nth-child(2){
      width: 100%;
    }
  }
  `;

const Wrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.S};
  border-left: ${({ theme }) => theme.variable.borderRadius} solid ${({ theme }) => theme.color.primary};
  background: ${({ theme }) => theme.color.background};
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  margin-bottom: ${({ theme }) => theme.space.M};
`
